import React, { useState } from 'react'
import ProjectSetup from './ProjectSetup'
import ColorPalette from './ColorPalette'
import YardageCalculator from './YardageCalculator'
import './Sidebar.css'
import ImageImporter from "../ImageImport/ImageImporter";

const Sidebar = () => {
  const [activeTab, setActiveTab] = useState('setup');

  return (
    <aside className="sidebar">
      <ImageImporter />


<div
  className="sidebar-tabs"
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 0,
    width: '100%',
    minWidth: 0,
    marginBottom: '10px',
    overflow: 'hidden',
  }}
>
  <button
    className={activeTab === "setup" ? "active" : ""}
    onClick={() => setActiveTab("setup")}
    style={{
      appearance: 'none',
      WebkitAppearance: 'none',
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      height: '40px',
      margin: 0,
      padding: '0 2px',
      border: '1.5px solid #3a3836',
      borderTopLeftRadius: '999px',
      borderBottomLeftRadius: '999px',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      background: activeTab === "setup" ? '#2f2b27' : '#ffffff',
      color: activeTab === "setup" ? '#ffffff' : '#1e1c1a',
      fontWeight: 600,
      fontSize: '11px',
      lineHeight: 1,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    Project
  </button>

  <button
    className={activeTab === "palette" ? "active" : ""}
    onClick={() => setActiveTab("palette")}
    style={{
      appearance: 'none',
      WebkitAppearance: 'none',
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      height: '40px',
      margin: 0,
      padding: '0 2px',
      border: '1.5px solid #3a3836',
      borderRadius: 0,
      background: activeTab === "palette" ? '#2f2b27' : '#ffffff',
      color: activeTab === "palette" ? '#ffffff' : '#1e1c1a',
      fontWeight: 600,
      fontSize: '11px',
      lineHeight: 1,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    Palette
  </button>

  <button
    className={activeTab === "yardage" ? "active" : ""}
    onClick={() => setActiveTab("yardage")}
    style={{
      appearance: 'none',
      WebkitAppearance: 'none',
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      height: '40px',
      margin: 0,
      padding: '0 2px',
      border: '1.5px solid #3a3836',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: '999px',
      borderBottomRightRadius: '999px',
      background: activeTab === "yardage" ? '#2f2b27' : '#ffffff',
      color: activeTab === "yardage" ? '#ffffff' : '#1e1c1a',
      fontWeight: 600,
      fontSize: '11px',
      lineHeight: 1,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    Yardage
  </button>
</div>

      <div className="sidebar-content">
  {activeTab === "setup" && (
    <div className="sidebar-panel">
      <ProjectSetup />
    </div>
  )}

  {activeTab === "palette" && (
    <div className="sidebar-panel">
      <ColorPalette />
    </div>
  )}

  {activeTab === "yardage" && (
    <div className="sidebar-panel">
      <YardageCalculator />
    </div>
  )}
</div>
    </aside>
  );

}; 


export default Sidebar;
